import { Box, Typography } from '@chronosphereio/chrono-ui';

export interface YAxisLabelProps {
  name: string;
  height: number;
  position?: 'left' | 'right';
}

export function YAxisLabel({ name, height, position = 'left' }: YAxisLabelProps) {
  let transform = 'translateX(-50%) rotate(-90deg)';
  if (position === 'right') {
    transform = 'translateX(50%) rotate(90deg)';
  }
  return (
    <Box
      sx={{
        display: 'inline-block',
        maxWidth: height, // allows rotated text to truncate instead of causing overlap
        position: 'absolute',
        top: `calc(${height}px / 2)`,
        left: position === 'left' ? 0 : 'auto',
        right: position === 'right' ? 0 : 'auto',
        transform: transform,
        transformOrigin: 'top',
        textAlign: 'center',
        zIndex: 1,
      }}
    >
      <Typography
        variant="body1"
        aria-label="y axis label"
        sx={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {name}
      </Typography>
    </Box>
  );
}
